import PropTypes from 'prop-types'
import React from 'react'
import SelectField from '../../molecules/fields/SelectField'
import * as validations from '../../../utils/validations'
import useTextValidation from '../../../hooks/useTextValidation'
import { getLabelWithManualRequest } from '../../../configs/formsConfig'
import clsx from 'clsx'
import { marginSizes } from '../../../configs/sizesConfig'
import { useField } from 'react-final-form'

const RepeatGroupCitizenField = ({
  name,
  baseName,
  index,
  payload,
  required,
  manualRequest = false,
  disabled = false,
  margin,
  onChange,
  id,
  childrenAttributes,
  optional
}) => {
  const baseLabel = index ? `${index}. ${payload?.label}` : payload?.label
  const label = getLabelWithManualRequest(baseLabel, manualRequest)
  const options = new Array(parseInt(payload.count)).fill(0).map((_, index) => ({ value: index + 1, label: index + 1 }))
  const translationText = useTextValidation()
  const { input: subAnswers } = useField(`${baseName}.sub_answers_attributes.${id}`)

  const handleChange = value => {
    if (subAnswers.value && subAnswers.value.length > 1) {
      const questionLength = Object.values(childrenAttributes)[0].length
      const filteredAnswers = subAnswers.value.filter((_, index) => questionLength * value > index)
      subAnswers.onChange(filteredAnswers)
    }
    onChange && onChange(value)
  }

  return (
    <div className={clsx('flex flex-col gap-2', marginSizes[margin])}>
      <SelectField
        name={`${name}.selected`}
        label={label}
        className="block"
        hint={payload?.hint}
        options={options}
        disabled={disabled}
        validate={required && validations.required(translationText.required)}
        margin={'none'}
        onChange={handleChange}
        size="2xl"
        optional={optional}
      />
    </div>
  )
}

export default RepeatGroupCitizenField

RepeatGroupCitizenField.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  baseName: PropTypes.string,
  onChange: PropTypes.func,
  payload: PropTypes.object,
  required: PropTypes.bool,
  manualRequest: PropTypes.bool,
  id: PropTypes.number,
  childrenAttributes: PropTypes.array,
  optional: PropTypes.bool
}
